@if (!editMode) {
  <h2 mat-dialog-title>
    Modul Bewegungs Scatterplot hinzufügen
  </h2>
}
@if (editMode) {
  <h2 mat-dialog-title>Modul Bewegungs Scatterplot editieren</h2>
}
<mat-dialog-content>
  <!-- <pre>Form values: {{ correlationForm?.value | json }}</pre> -->
  <div>
    <form
      [formGroup]="correlationForm"
      (ngSubmit)="updateOrCreateModule()"
      ngNativeValidate
      class="d-flex flex-column"
      >
      <mat-form-field>
        <mat-label>Überschrift</mat-label>
        <input matInput formControlName="headline" required />
        @if (correlationForm.controls.headline.hasError('required')) {
          <mat-error
            >Überschrift angeben</mat-error
            >
          }
        </mat-form-field>

        <mat-label>Visualisierbare Daten</mat-label>
        <div class="user-selection-group">
          <ng-container formArrayName="datasources">
            @for (datasource of availableDataSources; track datasource; let i = $index) {
              <div
                class="list-group-item"
                [formGroupName]="i"
                >
                <mat-checkbox formControlName="checked">
                  {{ datasource.display_name }}
                </mat-checkbox>
              </div>
            }
          </ng-container>
        </div>

        <mat-slide-toggle formControlName="timePeriodFiltered"
          >{{ "app.filterTimePeriod" | translate }}</mat-slide-toggle
          >
          <div class="d-flex flex-row">
            <mat-form-field class="p-2">
              <mat-label>Startzeit</mat-label>
              <input
                [attr.disabled]="timeFilterDisabled"
                matInput
                formControlName="timePeriodFilteredFrom"
                />
              @if (
                correlationForm.controls.timePeriodFilteredFrom.hasError(
                'validTime'
                )
                ) {
                <mat-error
                  >Zeitraum im Format [hh:mm] angeben</mat-error
                  >
                }
              </mat-form-field>

              <mat-form-field class="p-2">
                <mat-label>Endzeit</mat-label>
                <input
                  [attr.disabled]="timeFilterDisabled"
                  matInput
                  formControlName="timePeriodFilteredTill"
                  />
                @if (
                  correlationForm.controls.timePeriodFilteredTill.hasError(
                  'validTime'
                  )
                  ) {
                  <mat-error
                    >
                    Zeitraum im Format [hh:mm] angeben</mat-error
                    >
                  }
                </mat-form-field>
              </div>

              <div>
                <div style="display: none">
                  <mat-label>Bild</mat-label>
                  <input
                    type="file"
                    (change)="onFileChange($event)"
                    name="Bild"
                    accept="image/*"
                    #file
                    />
                </div>
                <mat-lab></mat-lab>
                <div
                  class="image-preview-wrapper d-flex justify-content-center"
                  (click)="file.click()"
                  >
                  <div class="image-preview">
                    @if (imagePreviewURL) {
                      <img #image [src]="imagePreviewURL" />
                    }
                    @if (!imagePreviewURL) {
                      <div class="image-placeholder">
                        <mat-icon>file_upload</mat-icon>
                        Bild auswählen
                      </div>
                    }
                  </div>
                </div>
              </div>

              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!correlationForm.valid || submitting"
                >
                @if (editMode) {
                  Speichern
                }
                @if (!editMode) {
                  Hinzufügen
                }
              </button>
            </form>
          </div>
        </mat-dialog-content>
